// Ile kolumn mieści się na danym progu. Od `d` rem jest zbity do 13-14 px (patrz
// `html` w global.css), więc kafel z okładką potrzebuje ok. 200 px — sidebar
// filtrów (310 px) zabiera jedną kolumnę na każdym progu.
const COLUMN_CAPS = {
  withSidebar: { t: 2, d: 3, ld: 4, '1.5xl': 5 },
  withoutSidebar: { t: 2, d: 4, ld: 5 },
}

// `desktopColumns` to górny limit kolumn widoku, sidebar przesuwa próg, od
// którego ten limit się pojawia.
export const resolveColumnsByBreakpoint = (desktopColumns, { withSidebar = false } = {}) => {
  const normalized = Number(desktopColumns)
  const target = Number.isFinite(normalized) ? Math.max(normalized, 2) : 4
  const caps = withSidebar ? COLUMN_CAPS.withSidebar : COLUMN_CAPS.withoutSidebar
  const columns = {}
  let previous = 1

  // Kolejne progi tylko wtedy, gdy faktycznie zmieniają liczbę kolumn — inaczej
  // klasy dublowałyby poprzedni próg.
  Object.entries(caps).forEach(([breakpoint, cap]) => {
    const count = Math.min(target, cap)

    if (count !== previous) {
      columns[breakpoint] = count
      previous = count
    }
  })

  return columns
}

// Literały — Tailwind nie wykryje klas składanych ze zmiennych.
const GRID_COLS = {
  t: { 2: 't:grid-cols-2', 3: 't:grid-cols-3', 4: 't:grid-cols-4' },
  d: { 2: 'd:grid-cols-2', 3: 'd:grid-cols-3', 4: 'd:grid-cols-4', 5: 'd:grid-cols-5' },
  ld: { 2: 'ld:grid-cols-2', 3: 'ld:grid-cols-3', 4: 'ld:grid-cols-4', 5: 'ld:grid-cols-5' },
  xl: { 2: 'xl:grid-cols-2', 3: 'xl:grid-cols-3', 4: 'xl:grid-cols-4', 5: 'xl:grid-cols-5' },
  '1.5xl': { 4: '1.5xl:grid-cols-4', 5: '1.5xl:grid-cols-5' },
}

const BORDER_ON = {
  t: 't:border-l t:pl-20',
  d: 'd:border-l d:pl-20',
  ld: 'ld:border-l ld:pl-20',
  xl: 'xl:border-l xl:pl-20',
  '1.5xl': '1.5xl:border-l 1.5xl:pl-20',
}

const BORDER_OFF = {
  t: 't:border-l-0 t:pl-0',
  d: 'd:border-l-0 d:pl-0',
  ld: 'ld:border-l-0 ld:pl-0',
  xl: 'xl:border-l-0 xl:pl-0',
  '1.5xl': '1.5xl:border-l-0 1.5xl:pl-0',
}

export const getGridColumnsClass = (columns) =>
  Object.entries(columns)
    .map(([breakpoint, count]) => GRID_COLS[breakpoint]?.[count])
    .filter(Boolean)
    .join(' ')

// Lewa kreska i odstęp dla każdego kafla poza pierwszym w rzędzie. Kolor
// obramowania podaje wywołujący — dotyczy tylko szerokości, którą tu ustawiamy.
export const getColumnBorderClasses = (index, columns) =>
  Object.entries(columns)
    .map(([breakpoint, count]) => (index % count === 0 ? BORDER_OFF[breakpoint] : BORDER_ON[breakpoint]))
    .join(' ')

export const getTileGridClass = (desktopColumns, options) =>
  getGridColumnsClass(resolveColumnsByBreakpoint(desktopColumns, options))

export const getTileBorderClasses = (index, { desktopColumns = 4, withSidebar = false } = {}) =>
  [
    'border-b border-blueish-blueish5',
    getColumnBorderClasses(index, resolveColumnsByBreakpoint(desktopColumns, { withSidebar })),
  ].join(' ')
